import React from 'react';
import { cx } from '../../utils/cx.js';

/** Pulsing placeholder block — size it with Tailwind classes. */
const Skeleton = ({ className = '' }) => (
  <div className={cx('animate-pulse rounded-lg bg-gray-200/80 dark:bg-white/5', className)} aria-hidden />
);

export default Skeleton;
